export const UI_5_3_tableRow = [
    [
      {
        cellName: "신청 일시",
        id: "regDtm",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "신청 사용자ID",
        id: "applyUserId",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "신청 사용자명",
        id: "applyUserName",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "신청 전화번호",
        id: "applyTelNo",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "신청 메일",
        id: "applyUserMail",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "신청 메모",
        id: "applyMemo",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "처리 사용자명",
        id: "procUserName",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "처리 일시",
        id: "procDtm",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "처리 사유",
        id: "procRsn",
        row: 1,
        col: 1,
        style: { width: "8%" },
      },
      {
        cellName: "처리 결과",
        id: "newUserRegStCd",
        row: 1,
        col: 1,
        style: { width: "10%" },
      },
      {
        cellName: "승인/반려",
        id: "stCd",
        row: 1,
        col: 1,
        style: { width: "8%" },
      }
    ]
]
  
  
  